import { Paper, useTheme } from '@mui/material';
import { FC, useEffect, useMemo } from 'react';
import { GoPlus } from "react-icons/go";
import { useNavigate } from 'react-router-dom';
import { ConfirmDialog } from '../../../Components/Dialog/variants/dialog-confirmation/dialog-confirmation.component';
import { ActionButtons } from '../../../Components/Form/ActionButtons/action-buttons.component';
import { Button } from '../../../Components/Form/Button/button.scomponent';
import { Placeholder } from '../../../Components/Placeholder/placeholder.component';
import { Table } from '../../../Components/Table/table.component';
import { BaseContentPage } from '../../../Components/Templates/BaseContentPage/base-content-page.componen';
import { BaseScreen } from '../../../Components/Templates/BaseScreen/basescreen.component';


import { useListArts } from './arts-list.hook';
import { DestroyArtsUseCase } from '../../../Usecase/Arts/destroy-arts-usecase';
import { ListArtsUseCase } from '../../../Usecase/Arts/list-arts-usecase';
import { ListCustomersUseCase } from '../../../Usecase/Customers/list-customers-usecase';
import { ButtonActionMenu } from '../../../Components/Form/ButtonActionsMenu/button-action-menu.component';

interface IArtList {
  listArtsUseCase: ListArtsUseCase
  destroyArtsUseCase: DestroyArtsUseCase
  listCustomersUseCase: ListCustomersUseCase
}
const ArtList : FC<IArtList> = ({ listArtsUseCase, destroyArtsUseCase, listCustomersUseCase }) => {
    const theme = useTheme()


    const {  list, setArtToDestroy, artToDestroy, handleDestroyArt, totalRegistersCustomer, loadCustomers, listCustomers, navigate } = useListArts({
      listArtsUseCase,
      destroyArtsUseCase,
      listCustomersUseCase
    })


    useEffect(() => {
        // listArts({ page: 1})
        loadCustomers({ page: 1})
    }, [])


    const columns = useMemo(() => {
        const createColumns: any[] = [
        
          {
            field: 'name',
            headerName: 'Cliente',
            flex: 1
          },
          {
            field: 'document',
            headerName: 'CNPJ',
            flex: 1
          },
          {
            field: "actions",
            headerName: "Ações",
            
            // renderCell: (params: any) => <ActionButtons params={params} setItemToDestroy={setArtToDestroy} editLink={`/art-form/${params.row.id}`} />
             renderCell: (params: any) => <ButtonActionMenu options={[
              {
                title: 'Acessar',
                onClick: () => navigate(`/arts-customer-details/${params.row.id}`),
              }
            ]} />
          }
        ];
      
        return createColumns;
      }, []);
   

    return (
        <BaseScreen>
        <ConfirmDialog title='Remover Caixa' onCancel={() => setArtToDestroy('')} description='Você tem certeza?' open={!!artToDestroy} onConfirm={handleDestroyArt}  /> 
            <Paper >
                <BaseContentPage 
                    title='Artes'
                    search
                    searchFunction={loadCustomers}
                    placeholderSearch='Pesquise pelo nome do cliente'
                    breadcrumb={[{ title: 'Artes', link: "/arts-list"}, { title: 'Listagem'}]}
                    Action={() => <Button LeftIcon={() => <GoPlus size={18} />} sx={{ width: '130px'}} boxLeftSx={{ gap: '10px', marginLeft: '5px'}} textSx={{ textTransform: 'Capitalize', fontWeight: 500}} onClick={() => navigate('/arts-form')}>Adicionar</Button>}
                >
                  {!!listCustomers?.length ? <Table data={listCustomers} isRowSelectable={() => false}  totalCount={totalRegistersCustomer} columns={columns} onPageChange={loadCustomers}  /> : <Placeholder description='Nenhum dado encontrado.' />}
                </BaseContentPage>
              
            </Paper>
                
        </BaseScreen>
    )
}

export { ArtList };
